(function () {
  'use strict';

  var FREE_SHIP = 49900;

  function formatMoney(cents) {
    return '₹' + Math.round(cents / 100).toLocaleString('en-IN');
  }

  var drawer = {
    el:       null,
    overlay:  null,
    itemsEl:  null,
    emptyEl:  null,
    footerEl: null,
    countEl:  null,
    countPlural: null,
    subtotalEl: null,
    shipMsg:  null,
    shipFill: null,
    loading:  false,

    init: function () {
      this.el        = document.getElementById('bb-cart-drawer');
      this.overlay   = document.getElementById('bb-drawer-overlay');
      this.itemsEl   = document.getElementById('bb-drawer-items');
      this.emptyEl   = document.getElementById('bb-drawer-empty');
      this.footerEl  = document.getElementById('bb-drawer-footer');
      this.countEl   = document.getElementById('bb-drawer-count');
      this.countPlural = document.getElementById('bb-drawer-count-plural');
      this.subtotalEl= document.getElementById('bb-drawer-subtotal');
      this.shipMsg   = document.getElementById('bb-drawer-ship-msg');
      this.shipFill  = document.getElementById('bb-drawer-ship-fill');

      if (!this.el) return;

      var self = this;
      document.getElementById('bb-drawer-close').addEventListener('click', function () { self.close(); });
      this.overlay.addEventListener('click', function () { self.close(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') self.close(); });

      // Cart icon in header — open drawer
      document.querySelectorAll('[data-bb-open-cart], .bb-nav__cart, [href="/cart"]').forEach(function (el) {
        if (el.tagName === 'A' && el.getAttribute('href') === '/cart') {
          el.addEventListener('click', function (e) {
            e.preventDefault();
            self.open();
          });
        }
      });

      // Intercept PDP add-to-cart form
      var pdpForm = document.getElementById('bb-product-form');
      if (pdpForm) {
        pdpForm.addEventListener('submit', function (e) {
          e.preventDefault();
          var variantInput = pdpForm.querySelector('[name="id"]');
          var qtyInput     = document.getElementById('bb-qty-input');
          var variantId    = variantInput ? variantInput.value : null;
          var qty          = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
          if (variantId) self.addItem(variantId, qty);
        });
      }

      // Intercept sticky bar ATC
      var stickyForm = document.getElementById('bb-sticky-form');
      if (stickyForm) {
        stickyForm.addEventListener('submit', function (e) {
          e.preventDefault();
          var variantInput = document.getElementById('bb-product-form') &&
                             document.getElementById('bb-product-form').querySelector('[name="id"]');
          var variantId = variantInput ? variantInput.value : null;
          if (variantId) self.addItem(variantId, 1);
        });
      }

      // Cross-sell add buttons inside drawer (delegated)
      this.el.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-bb-cross-add]');
        if (btn) {
          e.preventDefault();
          self.addItem(btn.dataset.bbCrossAdd, 1);
        }
      });

      // Expose globally so Liquid onclick= refs work
      window.bbCartDrawer = this;
    },

    open: function () {
      this.el.classList.add('is-open');
      this.el.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      this.refresh();
    },

    close: function () {
      this.el.classList.remove('is-open');
      this.el.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    },

    addItem: function (variantId, qty) {
      var self = this;
      this.setLoading(true);
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId, 10), quantity: qty })
      })
        .then(function (r) { return r.json(); })
        .then(function () { self.open(); })
        .catch(function () { self.setLoading(false); });
    },

    updateLine: function (line, qty) {
      var self = this;
      this.setLoading(true);
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: qty })
      })
        .then(function (r) { return r.json(); })
        .then(function () { self.refresh(); })
        .catch(function () { self.setLoading(false); });
    },

    refresh: function () {
      var self = this;
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) { self.render(cart); })
        .catch(function () { self.setLoading(false); });
    },

    render: function (cart) {
      var self = this;
      var count = cart.item_count || 0;
      if (this.countEl)   this.countEl.textContent   = count;
      if (this.countPlural) this.countPlural.textContent = count === 1 ? '' : 's';

      // Update header cart count badge everywhere on the page
      document.querySelectorAll('[data-bb-cart-count]').forEach(function (el) {
        el.textContent = count;
        el.style.display = count > 0 ? '' : 'none';
      });

      // Shipping bar
      var remaining = FREE_SHIP - cart.total_price;
      var pct = Math.min(100, Math.round(cart.total_price * 100 / FREE_SHIP));
      if (this.shipFill) this.shipFill.style.width = pct + '%';
      if (this.shipMsg) {
        this.shipMsg.innerHTML = remaining <= 0
          ? '<svg width="13" height="13" viewBox="0 0 13 13" fill="none"><path d="M2 7l3.5 3.5L11 3" stroke="var(--bb-crimson)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg> You\'ve unlocked <strong>free shipping.</strong>'
          : '<svg width="13" height="13" viewBox="0 0 13 13" fill="none"><rect x="1" y="8" width="11" height="4" rx="1" stroke="currentColor" stroke-width="1.2"/><path d="M1 8V5l3-4h5l2 4v3" stroke="currentColor" stroke-width="1.2" stroke-linejoin="round"/></svg> Add <strong>' + formatMoney(remaining) + '</strong> more for free shipping.';
      }

      // Items
      if (count === 0) {
        this.itemsEl.innerHTML = '';
        this.emptyEl.style.display = 'flex';
        this.footerEl.style.display = 'none';
      } else {
        this.emptyEl.style.display = 'none';
        this.footerEl.style.display = 'flex';
        if (this.subtotalEl) this.subtotalEl.textContent = formatMoney(cart.total_price);

        var html = '';
        cart.items.forEach(function (item, i) {
          var lineNum = i + 1;
          var imgHTML = item.image
            ? '<img src="' + item.image.replace(/(\.[a-z]+)$/, '_240x$1') + '" alt="' + (item.title || '').replace(/"/g, '&quot;') + '" width="80" loading="lazy">'
            : '';
          html += '<div class="bb-drawer-line" data-line="' + lineNum + '">'
            + '<div class="bb-drawer-line__img">' + imgHTML + '</div>'
            + '<div class="bb-drawer-line__info">'
            +   '<div>'
            +     '<div class="bb-drawer-line__meta">Soft Lip Blur · 3ml</div>'
            +     '<div class="bb-drawer-line__name">' + (item.product_title || item.title) + '</div>'
            +   '</div>'
            +   '<div class="bb-drawer-line__bottom">'
            +     '<div class="bb-drawer-line__qty">'
            +       '<button class="bb-drawer-line__qty-btn" data-line="' + lineNum + '" data-qty="' + (item.quantity - 1) + '" aria-label="Decrease">'
            +         '<svg width="10" height="2" viewBox="0 0 10 2" fill="none"><line x1="0" y1="1" x2="10" y2="1" stroke="currentColor" stroke-width="1.5"/></svg>'
            +       '</button>'
            +       '<span class="bb-drawer-line__qty-val">' + item.quantity + '</span>'
            +       '<button class="bb-drawer-line__qty-btn" data-line="' + lineNum + '" data-qty="' + (item.quantity + 1) + '" aria-label="Increase">'
            +         '<svg width="10" height="10" viewBox="0 0 10 10" fill="none"><line x1="5" y1="0" x2="5" y2="10" stroke="currentColor" stroke-width="1.5"/><line x1="0" y1="5" x2="10" y2="5" stroke="currentColor" stroke-width="1.5"/></svg>'
            +       '</button>'
            +     '</div>'
            +     '<span class="bb-drawer-line__price">' + formatMoney(item.line_price) + '</span>'
            +   '</div>'
            +   '<button class="bb-drawer-line__remove" data-line="' + lineNum + '" data-qty="0">Remove</button>'
            + '</div>'
            + '</div>';
        });
        this.itemsEl.innerHTML = html;

        // Qty + remove listeners
        this.itemsEl.querySelectorAll('.bb-drawer-line__qty-btn, .bb-drawer-line__remove').forEach(function (btn) {
          btn.addEventListener('click', function () {
            self.updateLine(parseInt(btn.dataset.line, 10), parseInt(btn.dataset.qty, 10));
          });
        });
      }

      this.setLoading(false);
    },

    setLoading: function (on) {
      this.loading = on;
      var panel = this.el && this.el.querySelector('.bb-cart-drawer__panel');
      if (!panel) return;
      var loader = panel.querySelector('.bb-cart-drawer__loading');
      if (!loader) {
        loader = document.createElement('div');
        loader.className = 'bb-cart-drawer__loading';
        loader.innerHTML = '<svg width="20" height="20" viewBox="0 0 20 20" fill="none"><circle cx="10" cy="10" r="8" stroke="var(--bb-ink-12)" stroke-width="2"/><path d="M10 2a8 8 0 0 1 8 8" stroke="var(--bb-crimson)" stroke-width="2" stroke-linecap="round"><animateTransform attributeName="transform" type="rotate" from="0 10 10" to="360 10 10" dur=".7s" repeatCount="indefinite"/></path></svg>';
        panel.appendChild(loader);
      }
      loader.classList.toggle('visible', on);
    }
  };

  document.addEventListener('DOMContentLoaded', function () {
    drawer.init();
  });
})();
